import { render, staticRenderFns } from "./DynamicCustomersDropDown.vue?vue&type=template&id=b2f12d90&"
import script from "./DynamicCustomersDropDown.vue?vue&type=script&lang=js&"
export * from "./DynamicCustomersDropDown.vue?vue&type=script&lang=js&"
import style0 from "./DynamicCustomersDropDown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports